import React from 'react'
import { Input, ToolTip, Span } from '@driftt/tide-core'

const selectAll = (bulkSelect, isChecked) => {
  return (
    <Input type="checkbox" checked={isChecked} onChange={bulkSelect} />
  )
}

const lastUpdatedCell = () => (
  <ToolTip tethered flow="down" component={<div className="contacts-table--tooltip-content">Last time the system updated<br /> the contact record</div>}>
    <Span>Last updated</Span>
  </ToolTip>
)

export const Columns = (bulkSelect, isChecked, onChange) => ([
  {
    label: selectAll(bulkSelect, isChecked),
    sortable: false,
    width: '20px'
  },
  {
    label: 'Contact',
    value: 'name',
    sortable: true,
    onClick: onChange,
    width: '300px'
  },
  {
    label: 'Email',
    sortable: true,
    value: 'email',
    onClick: onChange,
    width: '200px'
  },
  {
    label: 'Lead stage',
    sortable: true,
    value: '_classification',
    onClick: onChange,
    width: '175px'
  },
  {
    label: lastUpdatedCell(),
    value: 'last_contacted',
    sortable: true,
    onClick: onChange,
    width: '150px'
  },
  {
    label: '',
    sortable: false,
    width: '71px'
  },
])
